import {
  AuthenticationApiRemoteService,
  TPasswordResetConfirmDTO,
  TPasswordResetMessageResponse,
} from '../../Services/api/auth/service-authentication'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class ConfirmPasswordResetUseCase
implements IFormUsecase<TPasswordResetConfirmDTO, TPasswordResetMessageResponse> {
  constructor(private readonly authApi: AuthenticationApiRemoteService) {}

  public async handle(
    data: TPasswordResetConfirmDTO
  ): Promise<Result<TPasswordResetMessageResponse>> {
    try {
      return await this.authApi.confirmPasswordReset(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
